import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { initSentry } from './helpers/sentry'
import { store } from 'store'
import aesInit from './aesInit'

import './index.scss'
import './theme/bootstrap-overrides.css'
import App from './App'
import { IS_INTEGRATED_VERSION } from './config/ConfigManager'

import { EmbeddedCommunicationsManager } from './api/embedded/EmbeddedCommunicationsManager'
import { Store } from './store/Store'
import { embeddedConfigManager } from './api/embedded/EmbeddedConfigManager'
import { setBrowserTitle } from './utils/setBrowserTitle'
import { reactErrorHandler } from '@sentry/react'

// Initialise Sentry.
initSentry()

// Set browser title with subdomain
setBrowserTitle()

const loadApp = () => {
  const container = document.getElementById('root')
  // https://docs.sentry.io/platforms/javascript/guides/react/#capture-react-errors-react-19
  const root = createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: reactErrorHandler((error, errorInfo) => {
      // eslint-disable-next-line no-console
      console.warn('Uncaught error', error, errorInfo.componentStack)
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: reactErrorHandler(),
  })
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Store>
          <App />
        </Store>
      </Provider>
    </React.StrictMode>
  )
}

if (IS_INTEGRATED_VERSION) {
  aesInit()
    .then((data) => {
      embeddedConfigManager.init(data)
      return EmbeddedCommunicationsManager.init()
    })
    .then(() => {
      loadApp()
    })
} else {
  loadApp()
}
